/**
 * Supabase Client Configuration
 * 
 * This file initializes the Supabase client for database operations.
 * Environment variables are loaded from .env.local (not committed to GitHub)
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables!');
  console.error('Make sure .env.local exists with:');
  console.error('  REACT_APP_SUPABASE_URL=your-url');
  console.error('  REACT_APP_SUPABASE_ANON_KEY=your-key');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
